import "./SkeletonStyle.css";

const QuotationDetailsSkeleton = () => {
  return (
    <div className="quotation-details-skeleton">
      {/* Back Link */}
      <div className="qd-skeleton-block qd-skeleton-back-link" />

      {/* Header */}
      <div className="qd-skeleton-header">
        <div className="qd-skeleton-block qd-skeleton-title" />
        <div className="qd-skeleton-block qd-skeleton-subtitle" />
      </div>

      <div className="qd-skeleton-layout">
        {/* Left Column */}
        <div className="qd-skeleton-left">
          {/* Main Card */}
          <div className="qd-skeleton-card">
            {/* Card Title */}
            <div className="qd-skeleton-block qd-skeleton-card-title" />

            {/* Details Row */}
            <div className="qd-skeleton-details-row">
              <div className="qd-skeleton-detail-box">
                <div className="qd-skeleton-block qd-skeleton-label" />
                <div className="qd-skeleton-block qd-skeleton-description" />
                <div className="qd-skeleton-block qd-skeleton-value" />
              </div>
              <div className="qd-skeleton-detail-box">
                <div className="qd-skeleton-block qd-skeleton-label" />
                <div className="qd-skeleton-block qd-skeleton-description" />
                <div className="qd-skeleton-block qd-skeleton-value" />
              </div>
            </div>

            {/* Included Services Section */}
            <div className="qd-skeleton-section">
              <div className="qd-skeleton-block qd-skeleton-section-title" />
              <div className="qd-skeleton-list">
                <div className="qd-skeleton-block qd-skeleton-list-item" />
                <div className="qd-skeleton-block qd-skeleton-list-item" />
                <div className="qd-skeleton-block qd-skeleton-list-item" />
                <div className="qd-skeleton-block qd-skeleton-list-item" />
                <div className="qd-skeleton-block qd-skeleton-list-item" />
              </div>
            </div>

            {/* Add-ons Section */}
            <div className="qd-skeleton-section">
              <div className="qd-skeleton-block qd-skeleton-section-title" />
              <div className="qd-skeleton-addons">
                <div className="qd-skeleton-addon-card">
                  <div className="qd-skeleton-block qd-skeleton-checkbox" />
                  <div className="qd-skeleton-addon-content">
                    <div className="qd-skeleton-block qd-skeleton-addon-name" />
                    <div className="qd-skeleton-block qd-skeleton-addon-desc" />
                  </div>
                  <div className="qd-skeleton-block qd-skeleton-addon-price" />
                </div>
                <div className="qd-skeleton-addon-card">
                  <div className="qd-skeleton-block qd-skeleton-checkbox" />
                  <div className="qd-skeleton-addon-content">
                    <div className="qd-skeleton-block qd-skeleton-addon-name" />
                    <div className="qd-skeleton-block qd-skeleton-addon-desc" />
                  </div>
                  <div className="qd-skeleton-block qd-skeleton-addon-price" />
                </div>
                <div className="qd-skeleton-addon-card">
                  <div className="qd-skeleton-block qd-skeleton-checkbox" />
                  <div className="qd-skeleton-addon-content">
                    <div className="qd-skeleton-block qd-skeleton-addon-name" />
                    <div className="qd-skeleton-block qd-skeleton-addon-desc" />
                  </div>
                  <div className="qd-skeleton-block qd-skeleton-addon-price" />
                </div>
                <div className="qd-skeleton-addon-card">
                  <div className="qd-skeleton-block qd-skeleton-checkbox" />
                  <div className="qd-skeleton-addon-content">
                    <div className="qd-skeleton-block qd-skeleton-addon-name" />
                    <div className="qd-skeleton-block qd-skeleton-addon-desc" />
                  </div>
                  <div className="qd-skeleton-block qd-skeleton-addon-price" />
                </div>
              </div>
            </div>
          </div>

          {/* Policy Cards Row */}
          <div className="qd-skeleton-policies">
            <div className="qd-skeleton-policy-card">
              <div className="qd-skeleton-block qd-skeleton-policy-title" />
              <div className="qd-skeleton-list">
                <div className="qd-skeleton-block qd-skeleton-list-item" />
                <div className="qd-skeleton-block qd-skeleton-list-item" />
                <div className="qd-skeleton-block qd-skeleton-list-item" />
                <div className="qd-skeleton-block qd-skeleton-list-item" />
              </div>
            </div>
            <div className="qd-skeleton-policy-card">
              <div className="qd-skeleton-block qd-skeleton-policy-title" />
              <div className="qd-skeleton-list">
                <div className="qd-skeleton-block qd-skeleton-list-item" />
                <div className="qd-skeleton-block qd-skeleton-list-item" />
                <div className="qd-skeleton-block qd-skeleton-list-item" />
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Summary */}
        <div className="qd-skeleton-right">
          <div className="qd-skeleton-summary-card">
            <div className="qd-skeleton-block qd-skeleton-summary-title" />
            
            <div className="qd-skeleton-summary-items">
              <div className="qd-skeleton-summary-row">
                <div className="qd-skeleton-block qd-skeleton-summary-label" />
                <div className="qd-skeleton-block qd-skeleton-summary-value" />
              </div>
              <div className="qd-skeleton-summary-row">
                <div className="qd-skeleton-block qd-skeleton-summary-label" />
                <div className="qd-skeleton-block qd-skeleton-summary-value" />
              </div>
            </div>

            <div className="qd-skeleton-block qd-skeleton-divider" />

            <div className="qd-skeleton-summary-row">
              <div className="qd-skeleton-block qd-skeleton-summary-label" />
              <div className="qd-skeleton-block qd-skeleton-summary-value-large" />
            </div>

            <div className="qd-skeleton-block qd-skeleton-down-payment" />
            
            <div className="qd-skeleton-block qd-skeleton-checkbox-agreement" />
            
            <div className="qd-skeleton-block qd-skeleton-button" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationDetailsSkeleton;

